module.exports = __webpack_public_path__ + "craftworkgrotesk-medium-webfont.b8950731ba88184483fd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/grotesc/craftworkgrotesk-medium-webfont.woff2
// module id = ./src/assets/webfonts/grotesc/craftworkgrotesk-medium-webfont.woff2
// module chunks = styles